/**
 * Development Page
 *
 * Page that displays the development summary to help developers
 * re-engage with the project.
 */

import React from 'react';
import { Layout, Typography } from 'antd';
import { DevelopmentSummaryComponent } from '../components/Development/DevelopmentSummary';
import { DemoTest } from '../components/Demo/DemoTest';

const { Content } = Layout;
const { Title } = Typography;

export const DevelopmentPage: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh', padding: '24px' }}>
      <Content>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <Title level={1} style={{ textAlign: 'center', marginBottom: '32px' }}>
            Development Dashboard
          </Title>
          <DevelopmentSummaryComponent />
          
          <div style={{ marginTop: '48px' }}>
            <Title level={2} style={{ textAlign: 'center', marginBottom: '24px' }}>
              Demo System Test
            </Title>
            <DemoTest />
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default DevelopmentPage;
